import styled from 'styled-components';

import { BoxPanel } from 'approot/shared/styles/box-panel.style';
import { rem } from 'approot/shared/style';
import * as Colors from 'approot/shared/styles/colours.style';

/**
 * Gets the actual color value from the color name
 * Falls back to a default color if the color name is not found
 */
const getColorValue = (colorName: string): string => {
  const colorValue = (Colors as any)[`${colorName}1`];
  return colorValue || Colors.blue1; // Fallback to blue1 if color not found
};

const getColorText = (colorName: string): string => {
  const colorValue = (Colors as any)[`${colorName}8`];
  return colorValue || Colors.blue8; // Fallback to blue6 if color not found
};

type ActivityEditorAvatarProps = {
  $backgroundColor: string;
};

export const ActivityEditorAvatar = styled(BoxPanel).attrs(props => ({
  $borderRadius: 40,
  $padding: 0,
  $alignItems: 'center',
  $justifyContent: 'center',
}))<ActivityEditorAvatarProps>`
  ${({ $backgroundColor }) => `
    background-color: ${getColorValue($backgroundColor)};
    color: ${getColorText($backgroundColor)};
  `}
  width: ${rem(40)};
  height: ${rem(40)};
`;
